import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-span-2 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5 p-4" }
const _hoisted_2 = { class: "flex flex-row gap-2" }

import { onBeforeMount, ref, watch } from 'vue';
import Input from '@/components/ui/input/Input.vue';
import Label from '@/components/ui/label/Label.vue';
import { patchPartnerSessionInactivityTimeout } from '@/http/partner';
import { useStore } from 'vuex';
import { STORAGE_CREDENTIALS, PARTNER_ID, PARTNER_SESSION_TIMEOUT } from '@/store';
import Button from '@/components/ui/button/Button.vue';
import { CircleCheck, LoaderCircle } from 'lucide-vue-next';
import { getSessionTimeoutLimit } from '@/http/customerSession';
import { set } from '@vueuse/core';

const DEFAULT_TIMEOUT = 24;

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatConfig',
  setup(__props) {

const sessionLimitTimeout = ref();
const isSessionTimeoutLimitValid = () => sessionLimitTimeout.value > 0 && sessionLimitTimeout.value <= 24 && Math.round(sessionLimitTimeout.value) === sessionLimitTimeout.value;
const showSessionLimitTimeoutError = ref(false);
watch(isSessionTimeoutLimitValid, () => {
  showSessionLimitTimeoutError.value = !isSessionTimeoutLimitValid();
});
const showSessionLimitTimeoutProgress = ref(false);
const showSessionLimitTimeoutSuccess = ref(false);

const store = useStore();

const updateTimeLimit = async () => {
  if (!isSessionTimeoutLimitValid()) {
    return;
  }
  set(showSessionLimitTimeoutProgress, true);
  try {
    await patchPartnerSessionInactivityTimeout(store.getters[PARTNER_ID], sessionLimitTimeout.value, store.getters[STORAGE_CREDENTIALS]);
    store.commit(PARTNER_SESSION_TIMEOUT, sessionLimitTimeout.value);

    setTimeout(() => {
      set(showSessionLimitTimeoutProgress, false);
      set(showSessionLimitTimeoutSuccess, true);

      setTimeout(() => {
        set(showSessionLimitTimeoutSuccess, false);
      }, 500);
    }, 500);
  } catch (err) {
    set(showSessionLimitTimeoutSuccess, false);
    set(showSessionLimitTimeoutError, true);
  }
};

onBeforeMount(async () => {
  sessionLimitTimeout.value = store.getters[PARTNER_SESSION_TIMEOUT]
    ?? await getSessionTimeoutLimit(store.getters[PARTNER_ID], store.getters[STORAGE_CREDENTIALS])
    ?? DEFAULT_TIMEOUT;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Label, {
      class: _normalizeClass({ 'text-red-500 border-red-500': showSessionLimitTimeoutError.value })
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Tempo de Expiração da Sessão (em horas)")
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Input, {
        type: "number",
        class: _normalizeClass({
          'w-16': true,
          'ring-red-500 border-red-500': showSessionLimitTimeoutError.value
        }),
        modelValue: sessionLimitTimeout.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sessionLimitTimeout).value = $event))
      }, null, 8, ["class", "modelValue"]),
      _createVNode(Button, {
        variant: "default",
        disabled: showSessionLimitTimeoutError.value,
        onClick: updateTimeLimit,
        class: _normalizeClass(["px-2", {
          'bg-success': showSessionLimitTimeoutSuccess.value
        }])
      }, {
        default: _withCtx(() => [
          (showSessionLimitTimeoutProgress.value)
            ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
                key: 0,
                class: "animate-spin"
              }))
            : (_openBlock(), _createBlock(_unref(CircleCheck), {
                key: 1,
                class: _normalizeClass({ 'animate-pulse': showSessionLimitTimeoutSuccess.value })
              }, null, 8, ["class"]))
        ]),
        _: 1
      }, 8, ["disabled", "class"])
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["text-red-500 text-xs", { invisible: !showSessionLimitTimeoutError.value }])
    }, " A sessão deve ser de pelo menos 1h no máximo 24h. ", 2)
  ]))
}
}

})